<template>
  <!-- 用户禁止操作-黑名单禁止充值 -->
  <div class="test-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="formData.user_id" placeholder="请输入用户UID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload accept=".xls,.xlsx" :show-file-list="false" :on-success="onSuccess" :on-error="onError"
            style="display: inline-flex; margin-right: 10px" :action="action" :headers="headers">
            <el-button size="small" type="primary" icon="el-icon-upload2">
              上传表(.xls/.xlsx)
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.user_id" placeholder="请输入用户UID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading" style="margin-bottom: 20px">
        <el-table-column prop="user_id" label="用户id" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="时间" align="center">
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button size="small" type="danger" @click="handleDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page" @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'
import {
  getCookie
} from '@/utils/cookie'
import saveFile from '@/utils/saveFile'

export default {
  data() {
    return {
      loading: false, //加载动画
      query: {
        page: 1,
        user_id: undefined
      },
      formData: {
        user_id: undefined,
      },
      dataList: undefined, //数据列表
      dataMeta: undefined, //底部跳转页面条
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}u_f_r_one_import`
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num == 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('u_f_r_one', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    //添加用户
    submit() {
      if (!this.formData.user_id) {
        this.$message.warning("请填写用户id")
        return
      }
      let params = this.formData
      postApiData('u_f_r_one', params).then(res => {
        if (res.code) {
          this.$message.success(res.message)
          this.getData() //刷新数据
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => { })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    //导出
    handleExport() {
      http
        .get(
          api + 'u_f_r_one_export', {
          responseType: 'arraybuffer'
        }
        )
        .then(res => {
          saveFile(res, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '禁止充值黑名单.xlsx'
          })
        }).finally(() => { })
    },
    downloadExcel() {
      //下载excel模版
      window.open('./excel/禁止充值黑名单.xlsx', '_blank')
    },
    handleDelete(row) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`u_f_r_one/${row.id}`).then((res) => {
          this.$message.success(res.message)
          this.getData()
        })
      })
    },
  }

}

</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {}

  .body-box {
    // width: 800px;
  }
}
</style>
